import React, { useEffect, useState } from 'react';

import { array, string } from 'prop-types';

import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import BobConfirmButton from './BobConfirmButton';
import BobCancelButton from './BobCancelButton';

import useApi from '../hooks/useApi';

import lambdaBaseApi from '../apis/lambda';

import template from 'url-template';

import * as ArchitectActions from '../actions/architectActions';
import * as BobActions from '../actions/bobActions';
import * as SiteActions from '../actions/siteActions';
import * as UiActions from '../actions/uiActions';

import * as classes from './BobFilterComponent.module.css';

const IssueTypesUrl = template.parse('/issuetypes');

const FILTER_OBJECT = {
    client:    '',
    site:      '',
    target:    '',
    issueType: '',
    priority:  ''
};

const formattedPriorities = [
    {
        id:   2,
        name: 'High'
    },
    {
        id:   1,
        name: 'Medium'
    },
    {
        id:   0,
        name: 'Low'
    }
];

const BobServiceManagementFilter = ({
    activeNavCompany,
    fetchClientSites,
    fetchNavClients,
    fetchEquipmentsBySiteId,
    navClients,
    sites,
    toggleLoading,
    targetNavClient,
    targetNavSite,
    ...props
}) => {

    const [filterOpen, setFilterOpen] = useState(false);
    const [filters, setFilters] = useState({...FILTER_OBJECT});
    const [equipments, setEquipments] = useState([]);
    const [formattedIssueTypes, setFormattedIssueTypes] = useState([]);

    const [issueTypes, fetchIssueTypes] = useApi(() => ({
        url: IssueTypesUrl.expand()
    }), lambdaBaseApi);

    useEffect(() => {
        if (activeNavCompany.id) {
            fetchNavClients(activeNavCompany.id);
            fetchIssueTypes();
        }
    }, [activeNavCompany.id]);

    useEffect(() => {
        if (issueTypes.data) {
            const payload = issueTypes.data.map(issueType => {
                issueType.name = issueType.label;
                if (issueType.name === 'healthAndSafety') issueType.name = 'Health and Safety';

                return { id: issueType.id, name: issueType.name };
            });

            const formatted = payload;

            setFormattedIssueTypes(formatted);
        }
    }, [issueTypes]);

    const handleToggle = () => {
        setFilterOpen(!filterOpen);
    };

    const handleClickAway = () => {
        // setFilterOpen(false);
    };

    const handleFilterApply = () => {
        setFilterOpen(false);
    };

    const handleClientChange = async event => {
        const { value } = event.target;
        await fetchClientSites(value);
        setFilters({
            ...filters, 
            client: value
        });
        toggleLoading(false);
    };

    const handleSiteChange = async event => {
        const { value } = event.target;
        setFilters({
            ...filters, 
            site: value
        });
        
        const equipments = await fetchEquipmentsBySiteId(value);
        let equipmentList = [];
        if (equipments) {
            // eslint-disable-next-line array-callback-return
            equipments.map(item => {
                equipmentList.push(
                    {
                        id:   item.id,
                        name: item.name
                    }
                );
            });
        }
        setEquipments(equipmentList);
        toggleLoading(false);
    };

    const handleEquipmentChange = async event => {
        const { value } = event.target;
        setFilters({
            ...filters, 
            equipment: value
        });
    };

    const handleIssueTypeChange = async event => {
        const { value } = event.target;
        setFilters({
            ...filters, 
            issueType: value
        });
    };

    const handlePriorityChange = async event => {
        const { value } = event.target;
        setFilters({
            ...filters, 
            priority: value
        });
    };

    return (
        <ClickAwayListener
            onClickAway={handleClickAway}
        >
            <span>
                <Button
                    className={classes.FilterButton}
                    onClick={handleToggle}
                >
                    <i className="fas fa-filter" aria-hidden="true" />
                </Button>
                {
                    filterOpen ? 
                        <Paper className={classes.BobFilterComponentMenu}>
                            <div className={classes.ServiceManagementFilter}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="client"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Client
                                    </InputLabel>
                                    <Select
                                        value={filters.client}
                                        onChange={handleClientChange}
                                        className={classes.select}
                                        inputProps={{
                                            name: 'client',
                                            id:   'client'
                                        }}
                                    >
                                        {
                                            navClients.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="site"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Site
                                    </InputLabel>
                                    <Select
                                        value={filters.site}
                                        onChange={handleSiteChange}
                                        className={classes.select}
                                        inputProps={{
                                            name: 'site',
                                            id:   'site'
                                        }}
                                    >
                                        {
                                            sites.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="equipment"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Target
                                    </InputLabel>
                                    <Select
                                        value={filters.equipment}
                                        onChange={handleEquipmentChange}
                                        className={classes.select}
                                        inputProps={{
                                            name: 'equipment',
                                            id:   'equipment'
                                        }}
                                    >
                                        {
                                            equipments.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="issueType"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Issue Type
                                    </InputLabel>
                                    <Select
                                        value={filters.issueType}
                                        onChange={handleIssueTypeChange}
                                        className={classes.select}
                                        inputProps={{
                                            name: 'issueType',
                                            id:   'issueType'
                                        }}
                                    >
                                        {
                                            formattedIssueTypes.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="priority"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                    >
                                        Priority
                                    </InputLabel>
                                    <Select
                                        value={filters.priority}
                                        onChange={handlePriorityChange}
                                        className={classes.select}
                                        inputProps={{
                                            name: 'priority',
                                            id:   'priority'
                                        }}
                                    >
                                        {
                                            formattedPriorities.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <BobCancelButton
                                    className={classes.Buttons}
                                    label={'Cancel'}
                                    cancel={handleToggle}
                                />
                                <BobConfirmButton
                                    className={classes.Buttons}
                                    label={'Ok'}
                                    onClick={handleFilterApply}
                                />
                            </div>
                        </Paper>
                        :
                        null
                }
            </span>
        </ClickAwayListener>
    );
};

BobServiceManagementFilter.defaultProps = {
    label: '',
    data:  []
};

BobServiceManagementFilter.propTypes = {
    label: string,
    data:  array
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        navClients:       state.bob.navClients,
        sites:            state.site.sites,
        targetNavClient:  state.bob.targetNavClient,
        targetNavSite:    state.bob.targetNavSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BobActions,
    ...SiteActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BobServiceManagementFilter));
